import { defineComponent, ref, onMounted} from 'vue';
import sys from '@truckdown/jsclient';

export default defineComponent({
    props: {
        image: {
            type: String,
            required: true
        },
        imageMob: {
            type: String,
            required: true
        },
        imagePosition: {
            type: String,
            required: true
        },
        heading: {
            type: String,
            required: true
        },
        headingCapital: {
            type: String,
            required: false,
            default: ''
        }
    },
    setup: function (props) {

        const isMobile = ref<boolean>(false);
        const checkIsMobile = () => {
            isMobile.value = window.innerWidth <= 600;
        }

        onMounted(() => {
            checkIsMobile()
            window.addEventListener('resize', checkIsMobile)
        })

        return {
            isMobile
        }
    }
});
